import React from 'react'
import { TooltipList } from '../../../design-system'
import { css } from '@emotion/css'

export function SizedTooltipList({ children }) {
  return (
    <TooltipList
      className={css`
        max-width: 260px;
      `}
      children={children}
    />
  )
}
